import ConfigData from "../Config/config.json";
import axios from "axios";
import { attachAuthRefreshInterceptor } from "./authRefreshInterceptor";
const data: any = ConfigData;
const website: any = process.env.REACT_APP_ENV;
// Exported so every refresh path resolves the endpoint the same way. Two of
// them computing it separately is how they would drift.
export const api_url = data[website]?.api_url;
export const search_api_url = data[website]?.search_api_url;

// Shared v1 clients: intentionally left WITHOUT interceptors, exactly as they
// were before v2. v1 modules import these and handle 401s their own way.
const defaultClient = axios.create({
  baseURL: api_url,
});

export const TeamClient = axios.create({
  baseURL: "https://api.htptv.net",
});

// v2-scoped clients: same bases as the shared clients above, but WITH the 401 ->
// refresh -> retry interceptor. The v2 data hooks call the bare clients directly
// and would otherwise fail on an expired token until a manual reload. Scoping the
// interceptor to these separate instances keeps v1's 401 behavior untouched.
// The refresh endpoint lives on api_url, so both refresh against the same URL.
export const v2Client = axios.create({ baseURL: api_url });
export const v2TeamClient = axios.create({ baseURL: "https://api.htptv.net" });
attachAuthRefreshInterceptor(v2Client, api_url);
attachAuthRefreshInterceptor(v2TeamClient, api_url);

// The search service, which serves highlights and the condensed game. Same
// refresh interceptor as the other v2 clients; tokens refresh against api_url
// regardless of which service rejected them.
export const v2SearchClient = axios.create({ baseURL: search_api_url });
attachAuthRefreshInterceptor(v2SearchClient, api_url);

export default defaultClient;
